const appUrl = "https://backend.vrfxbroker.com";


export const weburl = `${window.origin}/`

export const ApiConfig = {

  register: "signup",
  signIn: "login",
  forgotPassword: "forgotpassword",
  verify_otp: "request-otp",
  create_pin: "request-otp-forgot-pin",
  changepassword: "changepassword",
  userDetails: "get-user-data",
  editProfile: "edit-user-profile",
  deposit_amount: "deposit-amount",
  withdrawal_amount: "withdrawal-amount",
  wallet_balance: "get-user-balance",
  get_master_listing: "master_listing_second",
  view_master: "calculation-master2",
  master_trade_list: "master-trade-list",
  fetch_master_balance: "fetch_master_balance",
  follow_master: "follow-master",
  master_transaction: "master-transactions",
  check_master_followed: "check_master_followed",
  remove_master: "remove-master",
  withdrawal_list: "withdrawal-list",
  withdrawal_delete: "withdrawal-amount-cancel",
  deposit_list: "deposit-list",
  calculation_master: "calculation-master",
  add_investment: "add-investment",

  master_deposit_withdrawal_listing: "master_deposit_withdrawal_listing",
  identityKyc: "user-kyc-vrfx",
  reduce_investment: "reduce_investment",
  user_documents_kyc: "user-documents-kyc",
  changePinNumber: "change-pin",
  view_term_condition: "view-term-condition",

  getTicketList: "my-tickets",
  createTicket: "create-ticket",
  seenTicket: "update-seen-true-message",
  getHistoryData: "user_deposit_withdrwal_masters",


  // ============URLs================
  baseUrl: `${appUrl}/api/rcbfx/`,
  baseProfile: `${appUrl}/api/profile/`,
  url: `${appUrl}/`,
  weburl: `${appUrl}/api/adminrcbfx/`,
  baseOtpUrl: `${appUrl}/api/rcbfx/`

};
